import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { Status } from '../../../../../../src/app/models/statusEnums';
import { saveAs } from "file-saver";

@Component({
  selector: 'app-lion-attachment-chips',
  templateUrl: './attachment-chips.component.html',
  styleUrls: ['./attachment-chips.component.scss']
})
export class LionAttachmentChipsComponent {

  @Input() attachments;
  @Input() source: string;
  @Input() showRemove: boolean = true;
  @Input() enableDownload = false;
  @Output() removeAttachment: EventEmitter<any> = new EventEmitter<any>();
  mimeTypes = [
    { extension: "csv", value: "text/csv;charset=utf-8" },
    { extension: "doc", value: "application/msword;charset=utf-8" },
    { extension: "gif", value: "image/gif;charset=utf-8" },
    { extension: "jpeg", value: "image/jpeg;charset=utf-8" },
    { extension: "jpg", value: "image/jpeg;charset=utf-8" },
    { extension: "png", value: "image/png;charset=utf-8" },
    { extension: "pdf", value: "application/pdf;charset=utf-8" },
    { extension: "ppt", value: "application/vnd.ms-powerpoint;charset=utf-8" },
    { extension: "rar", value: "application/x-rar-compressed;charset=utf-8" },
    { extension: "xls", value: "vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8" },
    { extension: "xlsx", value: "vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8" },
    { extension: "zip", value: "application/zip;charset=utf-8" },
    { extension: "txt", value: "text/plain;charset=utf-8" }
  ];
  constructor() { }

  remove(index: number) {
    this.attachments[index].attachment.statusId = Status.Deleted;
    this.removeAttachment.emit(this.attachments);
  }

  downloadFile(name: string, content: string) {
    let ext = name.substring(name.lastIndexOf('.') + 1);

    let mime_type = this.mimeTypes.filter(el => el.extension === ext);
    if (mime_type.length > 0) {
      const base64 = content;
      const mime = mime_type[0].value;
      const blob = this.dataURItoBlob(base64, mime);
      const file = new File([blob], name, { type: mime });
      saveAs(file, name)
    }
  }

  dataURItoBlob(dataURI: string, mimeType: string) {
    const kept = dataURI.split(",", 2);
    const byteString = atob(kept[1]);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([int8Array], { type: mimeType });
    return blob;
  }

  download(url, downloadName) {
    window.open(url, '_blank');


    // let a = document.createElement("a");
    // document.body.appendChild(a);
    // a.href = url;
    // a.download = downloadName;
    // a.click();
    // document.body.removeChild(a);
  }

  downloadFile2(fileName: string, base64Data: string) {
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/octet-stream' });
    saveAs(blob, fileName);
  }

}
